import React, { useState, useRef, useEffect } from "react"
import Image from "../components/image"
import sliderData from "../data/slider.json"
import { useSwipeable } from "react-swipeable"
import VisibilitySensor from "react-visibility-sensor"

export default function Slider({ id, slides }) {
  let images, title
  if (id && !slides) {
    images = sliderData.find(obj => {
      return obj.id === id
    }).images
    title = sliderData.find(obj => {
      return obj.id === id
    }).title
  } else {
    images = slides
  }
  const sliderHeader = useRef()
  const [offset, setOffset] = useState(0)
  const [slideNumber, setSlideNumber] = useState(1)
  const [slidewidth, setSlideWidth] = useState(400)
  const slidemargin = 20
  const [autoPlayStatus, setAutoPlayStatus] = useState(false)
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => clickRight(),
    onSwipedRight: () => clickLeft(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  })

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      let padding = window
        .getComputedStyle(sliderHeader.current, null)
        .getPropertyValue("padding-left")
      setSlideNumber(1)
      setOffset(sliderHeader.current.offsetLeft + parseInt(padding))
      if (window.innerWidth < 600) {
        setSlideWidth(250)
      } else {
        setSlideWidth(400)
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize)
  }, []) // Empty array ensures that effect is only run on mount

  // Autoplay the slideshow if the prop is set to true, stop autoplay when the user is interacting with the slideshow
  useEffect(() => {
    if (autoPlayStatus === true) {
      const interval = setInterval(moveRight, 5000)
      return () => clearInterval(interval)
    }
  }, [offset, autoPlayStatus, slideNumber])

  function clickLeft() {
    setAutoPlayStatus(false)
    moveLeft()
  }

  function clickRight() {
    setAutoPlayStatus(false)
    moveRight()
  }

  function moveLeft() {
    if (slideNumber !== 1) {
      setOffset(offset + slidewidth + slidemargin)
      setSlideNumber(prevSlideNumber => prevSlideNumber - 1)
    }
  }

  function moveRight() {
    if (slideNumber !== images.length) {
      setOffset(offset - slidewidth - slidemargin)
      setSlideNumber(prevSlideNumber => prevSlideNumber + 1)
    } else {
      setSlideNumber(1)
      let padding = window
        .getComputedStyle(sliderHeader.current, null)
        .getPropertyValue("padding-left")
      setSlideNumber(1)
      setOffset(sliderHeader.current.offsetLeft + parseInt(padding))
    }
  }

  return (
    <VisibilitySensor
      partialVisibility={true}
      onChange={isVisible => {
        if (isVisible) {
          setAutoPlayStatus(true)
        }
      }}
    >
      <section id={`slider-${id}`} className="slider">
        <header className="container container--medium" ref={sliderHeader}>
          {title ? (
            <h3 className="title--tertiary title--uppercase">{title}</h3>
          ) : null}
          <nav>
            <button
              className={
                slideNumber === 1
                  ? "slider__button slider__button--disabled icon--arrow-left"
                  : "slider__button icon--arrow-left"
              }
              onClick={() => clickLeft()}
              aria-label="Advance slideshow left"
              aria-controls={`slider-${id}`}
            ></button>
            <button
              className="slider__button icon--arrow-right"
              onClick={() => clickRight()}
              aria-label="Advance slideshow right"
              aria-controls={`slider-${id}`}
            ></button>
          </nav>
        </header>
        <div className="slider__container" {...swipeHandlers}>
          <ul
            className="slider__slides"
            style={{
              width: images.length * slidewidth + images.length * slidemargin,
              transform: `translateX(${offset}px)`,
            }}
          >
            {images.map((image, index) => (
              <li
                key={index}
                style={{
                  width: slidewidth,
                }}
              >
                <Image
                  path={image.imagePath}
                  alt={image.alt ? image.alt : image.title}
                />
                {image.title ? (
                  <p className="caption">{image.title}{image.name && ` ${image.name}`}</p>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </VisibilitySensor>
  )
}
